<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-checkbox
        v-model="clase.equipaje_personal.aplica_adult"
        class="my-checkbox"
        :label="$t('lbl.equipaje_personal.adul')"
        hide-details
        disabled
      ></v-checkbox>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-checkbox
        v-model="clase.equipaje_personal.aplica_child"
        class="my-checkbox"
        :label="$t('lbl.equipaje_personal.child')"
        hide-details
        disabled
      ></v-checkbox>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-checkbox
        v-model="clase.equipaje_personal.aplica_inf"
        class="my-checkbox"
        :label="$t('lbl.equipaje_personal.inf')"
        hide-details
        disabled
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    clase: {
      type: Object,
    },
  },
}
</script>

<style scoped>
::v-deep .my-checkbox .v-label {
    font-size: 12px !important;
    line-height: 1;
    min-height: 8px;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
